var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3730_51584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5501 2.49998C7.30844 2.38331 3.83344 5.79165 3.83344 9.99998H2.34177C1.96677 9.99998 1.78344 10.45 2.05011 10.7083L4.37511 13.0416C4.54177 13.2083 4.80011 13.2083 4.96677 13.0416L7.29177 10.7083C7.55011 10.45 7.36677 9.99998 6.99177 9.99998H5.50011C5.50011 6.74998 8.15011 4.12498 11.4168 4.16665C14.5168 4.20831 17.1251 6.81665 17.1668 9.91665C17.2084 13.175 14.5834 15.8333 11.3334 15.8333C9.99177 15.8333 8.75011 15.375 7.76677 14.6C7.43344 14.3416 6.96677 14.3666 6.66677 14.6666C6.31677 15.0166 6.34177 15.6083 6.73344 15.9083C8.00011 16.9083 9.59177 17.5 11.3334 17.5C15.5418 17.5 18.9501 14.025 18.8334 9.78331C18.7251 5.87498 15.4584 2.60831 11.5501 2.49998ZM11.1251 6.66665C10.7834 6.66665 10.5001 6.94998 10.5001 7.29165V10.3583C10.5001 10.65 10.6584 10.925 10.9084 11.075L13.5084 12.6166C13.8084 12.7916 14.1918 12.6916 14.3668 12.4C14.5418 12.1 14.4418 11.7166 14.1501 11.5416L11.7501 10.1166V7.28331C11.7501 6.94998 11.4668 6.66665 11.1251 6.66665Z",
    fill: "#28519E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3730_51584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/History-icon.8cd56c5c0147553c8a92bb30eb4f3786.svg";
export { ForwardRef as ReactComponent };